import { IStoredFilters } from '@models/IStoredFilters';
import { Form } from 'formik';
import { PropsWithChildren, useEffect } from 'react';

interface Props {
  readonly values: IStoredFilters;
  readonly onChange: (params: IStoredFilters) => void;
}

const FormWrapper = ({
  values,
  children,
  onChange,
}: PropsWithChildren<Props>) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: Intentional Missing Dependencies
  useEffect(() => {
    if (values) onChange?.(values);
  }, [values]);

  return (
    <Form
      key="Form"
      className="relative flex h-full flex-col overflow-auto px-5 text-black-100 md:px-10 lg:px-20"
    >
      {children}
    </Form>
  );
};

export default FormWrapper;
